export const MODEL_VIEWER_POST_EFFECT_STRENGTH_MIN = 0;
export const MODEL_VIEWER_POST_EFFECT_STRENGTH_MAX = 1;

export interface ModelViewerPreviewPostEffectsData {
    diffusion: number
    grain: number
    highlight_rolloff: number
    vignette: number
}

export const DEFAULT_MODEL_VIEWER_POST_EFFECTS:ModelViewerPreviewPostEffectsData = {
    diffusion: 0,
    grain: 0,
    highlight_rolloff: 0,
    vignette: 0,
};

export const isModelViewerPostEffectStrength = (
    value:unknown,
):value is number => (
    typeof value === 'number'
    && Number.isFinite(value)
    && value >= MODEL_VIEWER_POST_EFFECT_STRENGTH_MIN
    && value <= MODEL_VIEWER_POST_EFFECT_STRENGTH_MAX
);

export const isModelViewerPreviewPostEffectsData = (
    value:unknown,
):value is ModelViewerPreviewPostEffectsData => {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        return false;
    }

    const postEffects = value as Record<string, unknown>;
    return (
        isModelViewerPostEffectStrength(postEffects.diffusion)
        && isModelViewerPostEffectStrength(postEffects.grain)
        && isModelViewerPostEffectStrength(postEffects.highlight_rolloff)
        && isModelViewerPostEffectStrength(postEffects.vignette)
    );
};

export const resolveModelViewerPostEffectsData = (
    value?:Partial<ModelViewerPreviewPostEffectsData>,
):ModelViewerPreviewPostEffectsData => ({
    diffusion: isModelViewerPostEffectStrength(value?.diffusion)
        ? value.diffusion
        : DEFAULT_MODEL_VIEWER_POST_EFFECTS.diffusion,
    grain: isModelViewerPostEffectStrength(value?.grain)
        ? value.grain
        : DEFAULT_MODEL_VIEWER_POST_EFFECTS.grain,
    highlight_rolloff: isModelViewerPostEffectStrength(value?.highlight_rolloff)
        ? value.highlight_rolloff
        : DEFAULT_MODEL_VIEWER_POST_EFFECTS.highlight_rolloff,
    vignette: isModelViewerPostEffectStrength(value?.vignette)
        ? value.vignette
        : DEFAULT_MODEL_VIEWER_POST_EFFECTS.vignette,
});

export const modelViewerPostEffectsAreActive = (
    value:ModelViewerPreviewPostEffectsData,
):boolean => (
    value.diffusion > MODEL_VIEWER_POST_EFFECT_STRENGTH_MIN
    || value.grain > MODEL_VIEWER_POST_EFFECT_STRENGTH_MIN
    || value.highlight_rolloff > MODEL_VIEWER_POST_EFFECT_STRENGTH_MIN
    || value.vignette > MODEL_VIEWER_POST_EFFECT_STRENGTH_MIN
);
